import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Checkbox from '@ontruck/ontruck-react-components/lib/Checkbox';
import style from './styles.module.scss';

class UsersRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabledRoutes: props.enabledRoutes || [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.enabledRoutes !== this.props.enabledRoutes) {
      this.setState({
        enabledRoutes: nextProps.enabledRoutes,
      });
    }
  }

  getRoutesToShow() {
    const { routes } = this.props;

    return routes.filter((r) => r.origin === r.destination);
  }

  areAllRoutesEnabled() {
    const { enabledRoutes } = this.state;

    const { routes } = this.props;

    return routes.length === enabledRoutes.length;
  }

  areNationalRoutesEnabled() {
    const { enabledRoutes } = this.state;

    const { routes } = this.props;

    const nationalRoutes = routes.filter((r) => !r.local);
    const nationalEnabledRoutes = enabledRoutes.filter((r) => !r.local);

    return (
      nationalEnabledRoutes.length > 0 && nationalRoutes.length === nationalEnabledRoutes.length
    );
  }

  existNationalRoutes() {
    const { routes } = this.props;

    return routes.filter((r) => !r.local).length > 0;
  }

  isRouteEnabled(route) {
    const { enabledRoutes } = this.state;

    return !!enabledRoutes.find((r) => route.symmetric_name === r.symmetric_name);
  }

  toggleRoute(route) {
    let { enabledRoutes } = this.state;

    const routeIsEnabled = this.isRouteEnabled(route);
    let newEnabledRoutes = [];

    if (routeIsEnabled) {
      newEnabledRoutes = enabledRoutes.filter((r) => r.symmetric_name !== route.symmetric_name);
    } else {
      newEnabledRoutes = [route].concat(enabledRoutes);
    }

    this.setState(
      {
        enabledRoutes: newEnabledRoutes,
      },
      () => this.props.onChange(this.props.country, this.state.enabledRoutes)
    );
  }

  toggleAllRoutes() {
    const { routes, country } = this.props;

    let newEnabledRoutes = [];

    if (!this.areAllRoutesEnabled()) {
      newEnabledRoutes = [].concat(routes);
    }

    this.setState(
      {
        enabledRoutes: newEnabledRoutes,
      },
      () => this.props.onChange(country, this.state.enabledRoutes)
    );
  }

  toggleNationalRoutes() {
    const { routes, country } = this.props;

    let { enabledRoutes } = this.state;

    let newEnabledRoutes = [];
    const notNationalEnabledRoutes = enabledRoutes.filter((r) => r.local);

    if (this.areNationalRoutesEnabled()) {
      newEnabledRoutes = [].concat(notNationalEnabledRoutes);
    } else {
      const nationalRoutes = routes.filter((r) => !r.local);
      newEnabledRoutes = notNationalEnabledRoutes.concat(nationalRoutes);
    }

    this.setState(
      {
        enabledRoutes: newEnabledRoutes,
      },
      () => this.props.onChange(country, this.state.enabledRoutes)
    );
  }

  render() {
    const { intl, country } = this.props;

    const t = intl.messages.components.UsersRoutes;
    const routesToShow = this.getRoutesToShow();

    return (
      <>
        <b>{country}</b>
        <div className={style.container}>
          <div className={style.checkboxAllContainer}>
            {routesToShow.length > 1 ? (
              <Checkbox
                className={style.checkboxAll}
                label={
                  <FormattedMessage
                    id="UserRoutes.all_routes"
                    defaultMessage={t.all_routes}
                    values={{ country: country }}
                  />
                }
                boxed
                checked={this.areAllRoutesEnabled()}
                onChange={() => this.toggleAllRoutes()}
              />
            ) : null}
          </div>
          <div className={style.checkboxRegContainer}>
            {routesToShow.map((route) => (
              <Checkbox
                className={style.checkbox}
                key={route.symmetric_name}
                label={route.simple_name}
                boxed
                checked={this.isRouteEnabled(route)}
                onChange={() => this.toggleRoute(route)}
              />
            ))}
            {this.existNationalRoutes() ? (
              <Checkbox
                className={style.checkbox}
                label={t.national}
                boxed
                checked={this.areNationalRoutesEnabled()}
                onChange={() => this.toggleNationalRoutes()}
              />
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

UsersRoutes.propTypes = {
  enabledRoutes: PropTypes.array,
  routes: PropTypes.array,
  country: PropTypes.string,
  intl: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default injectIntl(UsersRoutes);
